import { render, staticRenderFns } from "./DiseaseActivityInfoDialog.vue?vue&type=template&id=bc69c1c6&scoped=true&"
import script from "./DiseaseActivityInfoDialog.vue?vue&type=script&lang=js&"
export * from "./DiseaseActivityInfoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc69c1c6",
  null
  
)

export default component.exports